export default {
  /**邀请返佣首页 start */
  inviToReback: "Lời mời và phần thưởng",
  accumuRewrds: "Tôi đã nhận được phần thưởng tích lũy",
  completedTranscation:
    "Khi người được giới thiệu hoàn thành hơn 1 lot hợp đồng vĩnh viễn thì có thể nhận được thêm 10USDT tiền thưởng",
  inviteQuick: "Không cần phải chờ đợi, hãy cùng nhau hành động ngay ~ ",
  currWeekRank: "Bảng xếp hạng tuần này",
  weekRank: "Danh sách xếp hạng",
  inviteNum: "Số lượng giới thiệu",
  rebackAmount: "Khoản tiền thưởng",
  checkAllRanks: "Xem danh sách đầy đủ",
  rebackRegu: "Quy tắc phần thưởng",
  rebaRegu1:
    "tiền thưởng hoàn lại khi giao dịch trong thời hạn chương trình, người được giới thiệu sau khi hoàn tất đăng ký tài khoản và giao dịch bất kỳ sản phẩm, người giới thiệu đều nhận được tiền thưởng hoàn tiền là 25% của phí giao dịch (phí mở vị thế + phí đóng vị thế). Lưu ý: giới hạn với mỗi khách là 500 USDT; và không giới hạn số lượng giới thiệu, giới thiệu càng nhiều nhận về càng nhiều 。",
  rebaRegu2:
    "Phần thưởng đợt hai: Trong thời hạn chương trình giới thiệu bạn bè, người được giới thiệu nếu có giao dịch trên 1 lot hợp đồng vĩnh viễn, người giới thiệu sẽ nhận được thêm tiền thưởng là 10USDT。",
  shareOnce: "Chia sẻ bằng một cú nhấp",
  sharOnceTitle: "Lời mời từ bạn {phone}",
  sharOnceText:
    "Đăng ký và hoàn tất thông tin cá nhân sẽ nhận ngay tiền thưởng",
  myBill: "Poster của tôi",
  shareToFace: "QR code",
  myShareQrCode: "Mã QR giới thiệu của tôi",
  shareActiveRegu: "Quy tắc hoạt động",
  shareActiveTime:
    "Thời gian chương trình: lâu dài Đối tượng tham gia: tài khoản thực;",
  shareActiveSpire:
    "Thời gian hoa hồng có hiệu lực: 60 ngày kể từ ngày khách hàng được giới thiệu kích hoạt tài khoản;",
  shareActiveReward:
    "Tiền thưởng giao dịch: trong thời hạn của cách tính tiền thưởng, người được giới thiệu sau khi hoàn thành đăng ký và kích hoạt tài khoản giao dịch, người giới thiệu sẽ nhận được hoa hồng tương ứng với USDT;",
  shareActiveTip:
    "Lưu ý: mỗi khách hàng nhận được nhiều nhất 500USDT, không giới hạn số lượng giới thiệu. Mời càng nhiều, hoa hồng càng nhiều.",
  shareActiveAtten: "Những vấn đề cần lưu ý:",
  shareAtiveRegu1:
    "Người được giới thiệu nhất định phải thông qua liên kết hoặc mã QR giới thiệu độc quyền của người giới thiệu, nếu không thì sẽ không được xem là giới thiệu thành công và đồng nghĩa người giới thiệu sẽ không nhận được bất kỳ hoa hồng hoặc tiền thưởng nào thông qua chương trình này. Chỉ có tài khoản thật mới có liên kết hoặc mã QR độc quyền;",
  shareAtiveRegu2:
    "Cách tính số lot giao dịch: số lot đóng vị thế trong 60 ngày kể từ ngày người được giới thiệu kích hoạt tài khoản;",
  shareAtiveRegu3:
    "Tiền thưởng sẽ được phát vào mỗi ngày làm việc (thứ hai đến thứ sáu), nếu là ngày lễ thì sẽ dời vào ngày làm việc tiếp theo.",
  shareAtiveRegu4:
    "Nếu trong thời gian chương trình diễn ra và phát hiện những hành vi vi phạm quy tắc nhận thưởng thì BTCC sẽ tự động hủy bỏ tư cách tham gia và nhận thưởng của khách hàng đó, đồng thời bảo lưu quyền truy đuổi;",
  shareAtiveRegu5:
    "Công ty có quyền giải thích cuối cùng các điều khoản này và quyền sửa đổi hoặc chấm dứt những ưu đãi bất cứ lúc nào mà không cần thông báo trước 。Công ty chúng tôi có quyền bảo lưu quyền giải thích cuối cùng và có quyền thay đổi hoặc hủy bỏ chương trình vào bất cứ lúc nào mà không cần thông báo cho khách hàng.",
  /**邀请返佣首页 end */

  /**邀请记录，返佣记录 start */
  inviteReocrd: "mời",
  rebackRecord: "cashback",
  invitedAccount: "Số tài khoản của người giới thiệu",
  inviteTime: "Thời gian giới thiệu",
  status: "Trạng thái",
  checkMore: "Xem chi tiết",
  noRecord: "Không có dữ liệu ！",
  type: "Thể loại",
  rebaNum: "Khoản tiền thưởng hoàn lại ",
  activited: "Đã kích hoạt",
  notActive: "Chưa kích hoạt",
  /**邀请记录，返佣记录 end */
  /**排行榜 start */
  rankList: "Bảng xếp hạng",
  yourCurrWeekData: "，Dữ liệu của bạn tuần này",
  billboard: "Bảng xếp hạng",
  phone: "Số điện thoại",
  cumulateReback: "Tích lũy tiền thưởng hoàn lại",
  noData: "Chưa có dữ liệu",
  /**排行榜 end */
  /**账户等级 start */
  account: "Tài khoản，",
  accountLevel: "Cấp độ tài khoản",
  miniAccount: "Tài khoản mini",
  stdAccount: "Tài khoản tiêu chuẩn",
  vipAccount: "Tài khoản vip",
  stdFeeCut: "Phí giao dịch sẽ được giảm 6,66%",
  vipFeeCut: "Phí giao dịch giảm mạnh tới 20%",
  currYouAre: "Quý khách hiện đang...",
  min: "Tài khoản mini，",
  std: "Tài khoản tiêu chuẩn，",
  dia: "Tài khoản vip，",
  superValueReco: "Giới thiệu",
  invest: "Nạp tiền（{unit}）",
  upgradeQuick: "Nâng cấp ngay",
  moreGradeProfit:
    "Sẽ có nhiều cấp độ tài khoản hơn được ra mắt, xin hãy luôn theo dõi chúng tôi ",
  konwAccountLevel: "Hiểu rõ về cấp độ tài khoản",
  whatsAccountLevel: "Cấp độ tài khoản là gì",
  thisIsAccountLevel:
    "Vui lòng liên hệ dịch vụ khách hàng để nâng cấp tài khoản dựa trên số USDT mà quý khách đã tích lũy; quý khách nạp tiền càng nhiều, cấp độ tài khoản càng cao thì sẽ được hưởng ưu đãi với phí giao dịch cực thấp cùng với vốn giao dịch cũng sẽ được giảm mạnh 。",
  whichAccountLevel: "Cấp độ tài khoản là gì",
  accountLevelTypes:
    "Cấp độ tài khoản của BTCC được chia thành 3 loại : mini , tiêu chuẩn và VIP",
  accountLevCondiAndProfit: "Điều kiện và lợi ích về cấp độ tài khoản",
  feeRate: "Tỷ lệ",
  level: "Cấp độ",
  deposit: "Nạp khoản",
  profit: "Quyền và lợi ích",
  mini: "Mini",
  noRights: "Không có quyền",
  standard: "Tiêu chuẩn ",
  stdFeeCuts: "Tỷ lệ giảm 6,66%",
  vipFeeCuts: "Tỷ lệ giảm 20%",
  moreCutToFees: "Cụ thể tỷ lệ khấu trừ vui lòng tham khảo tỷ lệ quỹ",
  example: "Ví dụ",
  exampleDetail:
    "“Lấy ví dụ giá thành của BTC/USDT là 8000 USDT để tính phí giao dịch, quý khách giao dịch tích lũy 50 lot hợp đồng vĩnh viễn BTC/USDT  ”",
  noRecharge: "(Không có khuyến mãi)",
  cut40: "(Giảm thẳng 40 USDT)",
  cut120: "(Giảm 120 USDT)",
  minGradeAtten: "Nâng cấp ngay để hưởng nhiều quyền lợi hơn！",
  stdGradeAtten: "Tiếp tục nâng cấp để hưởng nhiều quyền lợi hơn ！",
  diaGradeAtten: "Giao dịch ngay bây giờ và tận hưởng nhiều khuyến mãi hơn ！",
  /**账户等级 end */

  /**账户升级start */
  appliUpgrade: "Yêu cầu nâng cấp",
  accountNumber: "Số tài khoản",
  upgradeTo: "Nâng cấp thành",
  submit: "Gửi",
  upgradeNeedKnow: "Hướng dẫn nâng cấp tài khoản: ",
  upgradeNeedKnow1:
    "1.Trước khi nâng cấp , vui lòng đảm bảo rằng tài khoản của quý khách không có vị thế và lệnh Dừng-Giới hạn ；",
  upgradeNeedKnow2:
    "2.Dịch vụ khách hàng sẽ xem xét và xử lý đơn đăng ký trước buổi trưa vào ngày làm việc tiếp theo sau khi quý khách gửi đăng ký   ；",
  upgradeNeedKnow3:
    "3.Sau khi phê duyệt, bạn chỉ cần đăng nhập lại để tận hưởng trải nghiệm đầu tư tốt hơn 。",
  accountUpgrade: "Nâng cấp thành công",
  applyPno: "Yêu cầu nâng cấp thành công! (Số yêu cầu: {pno})",
  applyNumber: "Số tài khoản BTCC của bạn ：",
  applyFrom: "Gửi đăng ký từ",
  applyTo: "Nâng cấp tài khoản thành",
  applyResTime:
    "Dịch vụ khách hàng sẽ xem xét và xử lý đơn đăng ký trước buổi trưa vào ngày làm việc tiếp theo sau khi quý khách gửi đăng ký  。",
  /**账户升级end */

  accountNoDot: "Tài khoản",
  bonus: "Tiền thưởng",
  cashBack: "Phần thưởng",

  // 邀请返佣
  inviteHasInvitedUser: "đã mời người dùng",
  inviteCumulativeBack: "Hoa hồng tích lũy(USDT)",
  inviteFriend: "Mời bạn bè",
  inviteFriendDesc:
    "Tham gia BTCC cùng tôi và quay tiền thưởng may mắn mỗi ngày! Trung tâm phúc lợi ưu đãi BTCC có phần thưởng lên đến 1BTC đang chờ bạn. Điền mã giới thiệu của tôi để đăng ký nào!",
  inviteMyInviteLink: "Links mời của tôi：",
  inviteShareLink: "Chia sẻ Links",
  inviteCode: "Mã mời：",
  inviteCopy: "copy",
  inviteNow: "Giấy mời",
  inviteToUser: "Mời người dùng",
  inviteMyReward: "Hoa hồng của tôi",
  inviteUser: "Người dùng",
  inviteRegisterTime: "Thời gian đăng ký",
  inviteNoInvitePerson: "Tạm không có người được mời,",
  inviteStartInvite: "Bắt đầu mời",
  inviteReward: "Hoa hồng（USDT）",
  inviteQRDesc: "Đăng ký BTCC tối đa có thể nhận 500USDT tiền thưởng",
  inviteQRJoin: "Quét mã gia nhập",
  inviteCopySuccess: "Copy thành công",
  inviteCopyError: "Copy thất bại",
  inviteFriendWin: "Mời bạn bè kiếm tiền dễ dàng",
  inviteWinPercent: "25%",
  inviteBack: "Ủy ban",
  inviteNoRecord: "No record",
  inviteSlogan:
    "Giới thiệu bạn bè giao dịch, có thể nhận tiền mặt đến <strong>500USDT</strong>",

  "您当前VIP等级,享受手续费折扣":
    "Cấp độ VIP hiện tại: <span class='{level}'></span> được giảm <span>{amount}</span> phí giao dịch",
  VIP交易费率: "Phí giao dịch VIP",
  VIP等级: "Cấp độ VIP",
  账户资金: "Quỹ tài khoản",
  币币交易手续费: "Phí quy đổi coin",
  合约交易手续费: "Phí giao dịch hợp đồng",
  前往充值: "Nạp tiền",
  前往充币:"Nạp tiền",
  充提币手续费: "Phí nạp rút coin",
  币种: "Loại coin",
  充币费用: "Phí nạp coin",
  提币费用: "Phí rút coin",
  最小提币数量: "Số tiền rút tối thiểu",
  最小充币数量: "Số tiền nạp tối thiểu",
  折扣: "Giảm {amount}",
  说明: "Chú thích:",
  说明1:
    "Khi bạn đáp ứng yêu cầu nâng cấp VIP, <strong>vui lòng chủ động liên hệ DVCSKH để nâng cấp.</strong>",
  说明2:
    "Khi đang nắm giữ vị thế hợp đồng sẽ không thể nâng cấp, bạn cần phải đóng tất cả các vị thế mới có thể nâng cấp.",
  说明3:
    "Quỹ tài khoản được tính bằng USDT, xấp xỉ bằng tổng tài sản của {amount}.",
  说明4: "Giao dịch BTCC không có phân thành taker/maker.",
  说明5:
    "Giao dịch hợp đồng bao gồm các giao dịch hợp đồng của tất cả các loại tiền điện tử.",
    说明6: "Trading fees are applied to the opening and closing of futures positions. ",
  vip权益全面升级: "Nâng cấp toàn diện quyền lợi VIP",
  生效时间: "Thời gian có hiệu lực: 2022/04/25 00:00:00 (UTC+8)",
  其他货币: "other coins",

  // 累计充值活动
  新手专享: "Độc quyền cho người mới",
  新手专享豪礼送: "Exclusive Bonus for Beginners",
  注册成功后等级赠金奖励:
    "Meet the deposit targets within {day} days after successful registration of BTCC, and you can enjoy the bonus of the corresponding target levels",
  立即报名: "Register Now",
  如何领取奖励: "How to Get Bonus",
  如何领取奖励第一步: "Step 1: Sign up for a BTCC account",
  如何领取奖励第二步: "Step 2: Register for the campaign",
  如何领取奖励第三步: "Step 3: Make deposits to meet the requirements",
  如何领取奖励第四步:
    "Step 4: Receive your bonus within 3 days after the 7-day campaign period",
  立即买币: "Buy crypto",
  立即充币: "Deposit crypto",
  储值福利进度: "{coin} My Bonus Progress",
  充值升级提示:
    "Make more deposits within {day} days after registration to earn up to 17,500USDT bonus.",
  活动举例: "Example",
  有效充值: "Deposit",
  累计返利: "Cumulative Bonus(USDT) ",
  活动规则及条款: "Campaign Rules & Terms",
  活动版权:
    "BTCC reserves the right of final interpretation of the campaign. If you have any questions, please contact our ",
  请联系客服: "customer service team",
  报名成功: "Registration Success ",
  充币提示:
    "You can now deposit the following coins. Tap on each of the coins to check your deposit progress.",
  我已了解: "Got it",
  充值升级下一级:
    "You have received <strong>{bonus}</strong> bonus.<br />Deposit a cumulative of <strong>{amount}</strong> to unlock the next level of reward!",
  不符合新手报名条件:
    "Sorry, you are not eligible to participate in this campaign.",
  前往福利中心参与其他活动:
    "Please visit our Free Bonus page for other campaigns.",

  我的赠金记录: "My Bonus History",
  福利中心: "Free Bonus",
  立即登录: "Đăng nhập",
  免费注册: "Đăng ký miễn phí",
  captcha_desc: "Slide to complete the image",
  当前等级: "当前等级：",
  当前: "",
  参数: " ",
  兑换手续费减免: "兌換手續費減免",
  提币手续费减免: "提幣手續費減免",
  月总成交量USD: "30日總成交量(USD)",
  账户资产USD: "帳戶資產(USD)",
  账户资产: "帳戶資產:",
  继续升级: "继续升级享受{amount}折扣",
  gotIt: "明白了",
  我的30日成交量: "我的30日成交量",
  最近30天成交的交易合约: "最近30天成交的交易合约，以USD计算",
  我的资产: "我的资产",
  昨日账户资产: "昨日账户资产（包含所有币种）的价值，以USD计算<span>*每天00:00 (UTC+8)更新</span>",
  "title": "10日交易挑战",
  "solgen": "做任务开盲盒！最高领取210USDT赠金及交易手续费全免！",
  "super": "超级大盲盒！",
  "super_award": "随机${min}-{max}USDT赠金",
  "supper_task": "领取任意7个盲盒后可领取",
  "supper_tip": "需要先完成每日任务领取7个盲盒哦",
  "supper_open": "拆盲盒",
  "day": "挑戰進度：第{day}天",
  "award_fee": "随机{min}%-{max}%合约手续费返现",
  "award_bouns": "随机${min}-${max}USDT赠金",
  "task_complete": "已完成<span>{reach}/{total}</span>笔交易",
  "contract_task": "合约任务",
  "task_need": "完成任意<span>{num}</span>笔交易",
  "get_award_fee": "已领取：{amount}%手续费返现",
  "get_award_bouns": "已领取：${amount}USDT赠金",
  "award_overdue": "已过期",
  "award_hasget": "已领取",
  "award_toget": "待领取",
  "task_nostart": "未开始",
  "task_ongoing": "进行中",
  "task_rules": "活动规则",
  "task_rules_content1": "1. 参与条件：2022/12/20 16:062022/12/23 10:00:00 (UTC+8) 后的VIP0用户。VIP0用户只需在此活动上线后升级至VIP1或以上的等级便会自动参与此活动。",
  "task_rules_content1_desc": "2022/12/20 16:062022/12/23 10:00:00 (UTC+8) 前已经从VIP0升级到VIP1-9的用户无法参与此活动。",
  "task_rules_content2":  "2. 當用戶升级至VIP1或以上後，活動便會立即開始。此活动頁的資訊於每日5:00AM （UTC+8）更新。",
  "task_rules_content3":  "3. 必须完成当日交易任务才能开启该日盲盒奖励。在当日结算时间前未完成当天交易任务即失效。当天结算时间后自动重置交易笔数，并自动开启下一天的交易任务；",
  "task_rules_content4":  "4. 盲盒共计两种奖励形式，手续费返现及USDT赠金。手续费返现为现金奖励，领取后将自动发放至账户余额中，现金可交易可提取。赠金仅能用作合约交易时产生的手续费用抵扣，将根据不同的VIP等级进行一定比例的抵扣；",
  "task_rules_content5": "5. 手续费返现奖励只会返现当天计算在活动中的交易笔数，超出当天任务的交易笔数不会进行返现；",
  "task_rules_content6":  "6. 大盲盒开启条件为必须先完成任意7天的交易任务并开启7个盲盒，如在活动结束前未满足条件则无法开启大盲盒；",
  "task_rules_content7":  "7. 盲盒奖励存在随机性和概率性；",
  "task_rules_content8":  "8. 盲盒奖励实时到账。如果奖励沒有及時到帳，請联系客服查询；",
  "task_rules_content9":  "9. 如您的账号在活动期间被限制或判定为异常状态，您将无法开启盲盒；",
  "task_rules_content10":  "10. 交易包含开仓、平仓及强平；交易产品包括所有USDT合约及币本位合约；交易笔数统计交易的次数。",
  "task_rules_content11":  "其他条款",
  "task_rules_content12":  "1. 活动期间，如有恶意刷量行为、批量注册小号、自买自卖、相互对敲等作弊行为，BTCC将保留立即取消任何表现出欺诈行为迹象的参与者参与自个的权利；",
  "task_rules_content13":  "2.BTCC保留自行决定取消或修改活动或活动规则的权利，无需事先通知；",
  "task_rules_content14":  "3. BTCC保留对本次活动的最终解释权。如有疑问，请联系客服。",
  "complete_task": "成功完成<span>{num}</span>个交易",
  "no_standard": "完成{num}个交易，未达标"
};



// WEBPACK FOOTER //
// ./src/locales/vi-VN.js